export default __webpack_public_path__ + "static/berufsreise.tropenwelt-c72183a8daabadea3b8143bafc9ec4a4.jpg";